import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPartnerPlans, setSelectedPlan } from 'actions/partnerPlans'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'
import { getPathName } from 'utils/getPathName'
import { getEmployeeId } from 'utils/getEmployeeId'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'

class ReviewPartnerPlans extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    getPartnerPlans: PropTypes.func.isRequired,
    handleLoadMore: PropTypes.func.isRequired,
    history: PropTypes.func.isRequired,
    partnerPlans: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    selectedPartner: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
    setSelectedPlan: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    partnerPlans: null,
    selectedPartner: null,
    currentUser: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      loadMore: false,
    }
  }  

  componentDidMount() {
    hasAccess(this.props.currentUser, 'Partner Plan', this.props.history)
    this.props.getPartnerPlans(
      constants.PARTNERPLAN.VIEW.REVIEWPLANS,
      getEmployeeId(this.props.selectedPartner, this.props.currentUser),
    )
  }

  handleSelectedPlan = (plan) => {
    this.props.setSelectedPlan(plan)
    const pathName = `${getPathName(this.props.currentUser, '/partnerplan/plan')}`
    this.props.history.push({ pathname: pathName })
  }

  handleLoadMore = () => {
    this.setState(prevState => ({
      loadMore: !prevState.loadMore,
    }), () => {
      this.props.getPartnerPlans(
        constants.PARTNERPLAN.VIEW.REVIEWPLANS,
        getEmployeeId(this.props.selectedPartner, this.props.currentUser),
        !this.props.currentUser.IsAdmin,
        (this.state.loadMore === true ? constants.PARTNERPLAN.PLAN_FILTER_ADMIN_YEAR : (getFiscalYearTimestamps().current.year - constants.PARTNERPLAN.PLAN_FILTER_PARTNER_YEAR)),
      )
    })

    /*
    if (this.state.loadMore === true) {
      this.setState({ loadMore: false }, () => {   })
      // setTimeout(() => { this.setState({ this.props.modalShow(id) }) }, 500)
    } else {
      this.setState({ loadMore: true }, () => {   })
      setTimeout(() => { this.setState({ loadMore: true }) }, 500)
    } */
  }

  handleIsLoadMore = () => {
    return this.state.loadMore
  }

  render() {
    const {
      routes, currentUser, partnerPlans, selectedPartner,
    } = this.props
    return (
      <Container>
        {routes.map((route, i) => (
          <RouteWithSubRoutes
            key={i}
            {...route}
            currentUser={currentUser}
            getPartnerPlans={this.props.getPartnerPlans}
            handleIsLoadMore={this.handleIsLoadMore}
            handleLoadMore={this.handleLoadMore}
            handleSelectedPlan={this.handleSelectedPlan}
            partnerPlans={partnerPlans}
            planView={constants.PARTNERPLAN.VIEW.REVIEWPLANS}
            selectedPartner={selectedPartner}
            setErrorMessage={this.props.setErrorMessage}
          />
            ))}
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlans: state.partnerPlans,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  setSelectedPlan,
  getPartnerPlans,
})(ReviewPartnerPlans))



// WEBPACK FOOTER //
// ./src/containers/ReviewPartnerPlans.js